import React, { useEffect, useState } from "react";
import AppContext from "./AppContext";

const AppState = ({ children, containers = [] }) => {
  const [isInitialised, setInitialised] = useState(false);

  let mapOfInstances = new Map();

  Object.keys(containers).forEach(k => {
    mapOfInstances.set(k, containers[k]());
  });

  useEffect(() => {
    setInitialised(true);
    updateChromeExtention(mapOfInstances);
  }, []);

  useEffect(() => {
    updateChromeExtention(mapOfInstances);
  });

  return (
    <AppContext.Provider value={mapOfInstances}>
      {isInitialised && children}
    </AppContext.Provider>
  );
};

const updateChromeExtention = mapOfInstances => {
  let stateData = {};
  mapOfInstances.forEach((instance, key) => {
    stateData[key] = instance.state;
  });

  window.postMessage(
    {
      type: "BC_REACT_STATE_MACHINE_SOURCE",
      instances: JSON.parse(JSON.stringify(stateData))
    },
    "*"
  );
};

export default AppState;
